export const useScrollReveal = () => {
    const observer = ref<IntersectionObserver | null>(null)

    const ensureObserver = () => {
        if (import.meta.server) return
        if (observer.value) return

        observer.value = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('revealed')
                        observer.value?.unobserve(entry.target)
                    }
                })
            },
            { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
        )
    }

    const scan = () => {
        if (import.meta.server) return
        ensureObserver()

        document.querySelectorAll('[data-reveal]:not(.revealed)').forEach((el) => {
            observer.value?.observe(el)
        })
    }

    const cleanup = () => {
        observer.value?.disconnect()
        observer.value = null
    }

    onMounted(() => {
        nextTick(() => scan())
    })

    onBeforeUnmount(() => cleanup())

    return { scan, cleanup }
}
